"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STEDI_FUNCTION_DISCLAIMER = void 0;
exports.STEDI_FUNCTION_DISCLAIMER = `This function is provided by Stedi and isn't a part of the JSONata standard library.`;
